import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";

export class PassiveInvoiceBadCredentialsError extends Error {
  constructor() {
    super(
      sntTranslate(
        marker("Credenziali sincronizzazione fatture passive non valide")
      )
    );
  }
}
